import { useMemo } from 'react';

import { RequestEventType } from '@/rtk-query.gql';

import { Request } from './constants';

export const useRequestState = (request?: Request) => {
  const currentState = useMemo(
    () =>
      request?.events
        .slice()
        .reverse()
        .find((e) => e.type !== RequestEventType.COMMENT)?.type,
    [request?.events],
  );
  return currentState;
};
